export const getBlogsData = (t) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const imageBase = `${publicUrl}/images`;

  return [
  {
    id: 1,
    slug: 'give-education',
    image: `${imageBase}/image9.jpeg`,
    date: { day: '15', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_1_category'),
    title: t('blog_post_1_title'),
    excerpt: t('blog_post_1_excerpt') || t('blog_post_1_title'),
    content: t('blog_post_1_content') || t('blog_post_1_title')
  },
  {
    id: 2,
    slug: 'universal-garbage-cans',
    image: `${imageBase}/image10.jpeg`,
    date: { day: '15', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_2_category'),
    title: t('blog_post_2_title'),
    excerpt: t('blog_post_2_excerpt') || t('blog_post_2_title'),
    content: t('blog_post_2_content') || t('blog_post_2_title')
  },
  {
    id: 3,
    slug: 'sun-and-sand',
    image: `${imageBase}/image11.jpeg`,
    date: { day: '15', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_3_category'),
    title: t('blog_post_3_title'),
    excerpt: t('blog_post_3_excerpt') || t('blog_post_3_title'),
    content: t('blog_post_3_content') || t('blog_post_3_title')
  },
  {
    id: 4,
    slug: 'helping-hands',
    image: `${imageBase}/image3.jpeg`,
    date: { day: '14', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_4_category'),
    title: t('blog_post_4_title'),
    excerpt: t('blog_post_4_excerpt') || t('blog_post_4_title'),
    content: t('blog_post_4_content') || t('blog_post_4_title')
  },
  {
    id: 5,
    slug: 'community-spirit',
    image: `${imageBase}/image5.jpeg`,
    date: { day: '13', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_5_category'),
    title: t('blog_post_5_title'),
    excerpt: t('blog_post_5_excerpt') || t('blog_post_5_title'),
    content: t('blog_post_5_content') || t('blog_post_5_title')
  },
  {
    id: 6,
    slug: 'water-for-all',
    image: `${imageBase}/image12.jpeg`,
    date: { day: '12', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_6_category'),
    title: t('blog_post_6_title'),
    excerpt: t('blog_post_6_excerpt') || t('blog_post_6_title'),
    content: t('blog_post_6_content') || t('blog_post_6_title')
  },
  {
    id: 7,
    slug: 'youth-empowerment',
    image: `${imageBase}/image8.jpeg`,
    date: { day: '11', month: 'Dec' },
    author: 'Admin',
    category: t('blog_post_7_category'),
    title: t('blog_post_7_title'),
    excerpt: t('blog_post_7_excerpt') || t('blog_post_7_title'),
    content: t('blog_post_7_content') || t('blog_post_7_title')
  }
  ];
};
